export const IRSH_QUERY_PARAMS = {
  ISSUE: 'issue',
  REASON: 'reason',
} as const;
